import { useEffect, useState } from 'react';

import Geocode from 'react-geocode';
import { usePlacesWidget } from 'react-google-autocomplete';
const apiKey = 'AIzaSyDldEugO3NcBg8xoV_vrbH4AuLYuLPOr4I';
// const apiKey = "AIzaSyATUiRvg1TjWejPBhpqB1DGUvsBY2CoTj8";
Geocode.setApiKey(apiKey);

function SearchBar(props: { fetchData: any; loading: boolean; useCurrentLocation: boolean }) {
  const { fetchData, loading, useCurrentLocation = false } = props;
  const [locationLoading, setLocationLoading] = useState<boolean>(false);
  // const [selectedPlace, setselectedPlace] = useState("");
  function getLocation() {
    setLocationLoading(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        console.log(pos.coords.latitude, pos.coords.longitude);
        Geocode.enableDebug();
        Geocode.fromLatLng(pos.coords.latitude.toString(), pos.coords.longitude.toString()).then(
          (response) => {
            const address = response.results[0].formatted_address;
            ref.current.value = address;
            setLocationLoading(false);
          },
          (error) => {
            setLocationLoading(false);
            console.error(error);
          }
        );
      });
    } else {
      console.log('Geolocation is not supported by this browser.');
    }
  }
  const { ref }: any = usePlacesWidget({
    apiKey: apiKey,
    options: {
      country: 'us',
      componentRestrictions: { country: 'us' },
      fields: [
        'address_components',
        'formatted_address',
        'name',
        'place_id',
        'reference',
        'adr_address',
      ],
      types: ['address'],
    },

    onPlaceSelected: (place) => {
      console.log({ place });

      if (place && place.address_components.length > 0) {
        // let add = "";
        // for (let i = 0; i < place.address_components.length; i++) {
        //   const element = place.address_components[i];
        //   if (i !== 7 && i !== 3) {
        //     if ([1, 2, 4].includes(i)) {
        //       add = add + ` ${element.short_name}`;
        //     } else {
        //       add = add + ` ${element.long_name}`;
        //     }
        //   }
        // }
        ref.current.value = place.formatted_address;
      }
      // ref.current.focus();
    },
  });
  const onSubmit = () => {
    console.log(ref.current.value, 'onsubmit');
    if (ref.current.value) {
      fetchData(ref.current.value);
    }
  };
  return (
    <div className="renew-popup-container">
      <div className="renew-popup-lookup-form">
        <label>Enter Home Address</label>
        <input
          ref={ref}
          style={{ width: '400px' }}
          className="renew-popup-bar-input"
          placeholder="Enter Home Address"
          onFocus={(e) => {
            e.target.parentElement?.classList.add('has-focus');
          }}
          onBlur={(e) => {
            e.target.parentElement?.classList.remove('has-focus');
          }}
          // value={selectedPlace}
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     e.stopPropagation();
          //     e.preventDefault();
          //     console.log("Pressin Enter");
          //     if (ref.current.value) {
          //       onSubmit();
          //     }
          //   }
          // }}
        />
        <button
          className="renew-primary-button-new"
          disabled={loading}
          type="button"
          onClick={onSubmit}
        >
          <span>Look Up</span>
        </button>
      </div>
      {useCurrentLocation ? (
        <div>
          <button
            className="renew-outline-button-new"
            onClick={getLocation}
            disabled={locationLoading}
          >
            <i className="fas fa-location"></i>
            Use current location
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default SearchBar;
